<template>
  <div class="mainContainer">
    <div class="nav">
      <div class="navContainer" style="width: 230px">
        <span style="color:red">*</span>
        <p>仓库名称：</p>
        <el-input v-model="warehouseIpt" size="mini" style="width:150px" placeholder="请输入仓库名称"/>
      </div>
      <div class="navContainer" style="width: 210px">
        <p>楼层名：</p>
        <el-input v-model="floorIpt" size="mini" style="width:150px" placeholder="请输入楼层名"/>
      </div>
      <div class="navContainer" style="width: 210px">
        <p>底盘号：</p>
        <el-input v-model="chassisIpt" size="mini" style="width:150px" placeholder="请输入底盘号"/>
      </div>
      <div class="navContainer" style="width: 240px">
        <p>库位状态：</p>
        <el-select v-model="timeIpt" filterable size="mini" style="width:150px" placeholder="请选择库位状态">
          <el-option v-for="item in stateOption2" :key="item.label" :label="item.label" :value="item.value"/>
        </el-select>
      </div>
      <div class="navBtn">
        <el-button size="small" class="searchBtn" @click="searchBtn">查询</el-button>
        <el-button size="small" class="resetBtn" @click="resetBtn">重置</el-button>
        <el-button v-if="isPark && isShow" size="small" type="primary" @click="addBtn">添加车位</el-button>
        <el-button v-if="!isPark && isShow" size="small" type="primary" @click="addBtn2">添加车道</el-button>
      </div>
    </div>
    <div class="content">
      <div v-for="item in floorArr" class="contentItem">
        <div class="contentItemTitle">第{{item.floorName}}：</div>
        <div class="contentItemContent">
          <el-popover
            placement="top"
            width="150"
            trigger="click"
            v-for="innerItem in item.locationList"
            popper-class="contentPopover"
          >
            <div class="btnContainer">
              <el-button plain style="width:100%;border-radius: 0;" @click="detail(innerItem.id)">查看</el-button>
              <el-button plain style="width:100%;margin-left: 0;border-radius: 0;" @click="change(innerItem.id)">修改</el-button>
              <el-button v-if="isPark" plain style="width:100%;margin-left: 0;border-radius: 0;" @click="changeState(innerItem.state)">车位故障</el-button>
              <el-button v-else plain style="width:100%;margin-left: 0;border-radius: 0;" @click="changeError">修改异常车位</el-button>
              <el-button plain style="width:100%;margin-left: 0;border-radius: 0;" @click="deleteBtn">删除</el-button>
            </div>
            <div slot="reference" class="contentItemContentItem" :style="divStyle(innerItem.status===0?2:innerItem.state===2?3:1)">
              <div v-if="innerItem.status===0 || !isPark" class="contentItemContentItem1">
                <p>{{innerItem.vehicleLane?innerItem.vehicleLane:innerItem.vehiclePosition}}</p>
                <p v-if="innerItem.status===0 || !isPark" :style="`padding-left:${isPark?0:'40px'}`">{{ isPark?'底盘号：':'待停用车位：' }}{{isPark?innerItem.numberPlates:(innerItem.parkingNum-innerItem.warehouNum)}}</p>
                <p v-if="innerItem.status===0 || !isPark" :style="`padding-left:${isPark?0:'40px'}`">{{ isPark?'入库时间：':'已停用车位：' }}{{isPark?innerItem.warehouTime:innerItem.warehouNum}}</p>
                <p v-if="innerItem.status===0 || !isPark" :style="`padding-left:${isPark?0:'40px'}`">{{ isPark?'停车计时：':'异常停用车位：' }}{{isPark?innerItem.useDate:innerItem.abnormalNum}}</p>
              </div>
              <div v-else class="contentItemContentItem2">
                <p>{{geyState(innerItem.status)}}</p>
              </div>
            </div>
          </el-popover>
        </div>
      </div>
    </div>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width='550px' center @close="dialogClose" :close-on-click-modal="false">
      <div class="company">
        <el-form :model="companyData" label-width="95px" :rules="rules" ref="ruleForm">
          <div-border label="基础信息">
            <el-form-item label="选择仓库：" prop="warehouse" style="margin-top: 10px;">
              <el-select v-model="companyData.warehouse" filterable size="mini" style="width:100%" placeholder="请选择仓库">
                <el-option v-for="item in warehouseOption" :key="item.label" :label="item.label" :value="item.value"/>
              </el-select>
            </el-form-item>
            <el-form-item label="选择楼层：" prop="floor">
              <el-select v-model="companyData.floor" filterable size="mini" style="width:100%" placeholder="请选择楼层">
                <el-option v-for="item in floorOption" :key="item.label" :label="item.label" :value="item.value"/>
              </el-select>
            </el-form-item>
            <el-form-item v-if="isPark" label="车位号：" prop="parking" style="margin-bottom: 20px">
              <el-input
                :style="'width:100%'"
                v-model="companyData.parking"
                placeholder="请输入车位号"
                autocomplete="off"
                size="mini"
              />
            </el-form-item>
            <el-form-item v-if="!isPark" label="车道名称：" prop="name">
              <el-input
                :style="'width:100%'"
                v-model="companyData.name"
                placeholder="请输入车道名称"
                autocomplete="off"
                size="mini"
              />
            </el-form-item>
            <el-form-item v-if="!isPark" label="可停车数量：" prop="num" style="margin-bottom: 20px">
              <el-input
                :style="'width:100%'"
                v-model="companyData.num"
                placeholder="请输入车道最多可停车数量"
                autocomplete="off"
                size="mini"
              />
            </el-form-item>
          </div-border>
          <div class="btnContainer">
            <el-button size="medium" class="searchBtn" :loading="addLoad" @click="addClick">确认</el-button>
            <el-button size="medium" class="resetBtn" @click="dialogClose">关闭</el-button>
          </div>
        </el-form>
      </div>
    </el-dialog>
    <el-dialog :title="isPark?'车位详情':'车道详情'" :visible.sync="detailDialogVisible" width='650px' center>
      <div class="detail">
        <div class="baseInfo">
          <div class="baseInfoTitle">
            <div class="line"/>
            <span>基础信息</span>
            <p>{{detailData.state}}</p>
          </div>
          <div class="baseInfoContent">
            <div class="baseInfoContentItem">
              <span class="span1">所属仓库：</span>
              <span>{{detailData.storehouseName}}</span>
            </div>
            <div class="baseInfoContentItem specialItem">
              <div class="specialOne">
                <span class="span1">楼层名：</span>
                <span>{{detailData.floorName}}</span>
              </div>
              <div v-if="isPark">
                <span class="span1">车位号：</span>
                <span>{{detailData.vehiclePosition}}</span>
              </div>
              <div v-if="isPark">
                <span class="span1">车牌号：</span>
                <span>{{detailData.numberPlates}}</span>
              </div>
            </div>
            <div class="baseInfoContentItem" v-if="!isPark">
              <span class="span1">车道名：</span>
              <span>{{detailData.vehicleLane}}</span>
            </div>
            <div class="baseInfoContentItem specialItem" v-if="isPark">
              <div class="specialOne">
                <span class="span1">入库时间：</span>
                <span>{{detailData.warehouTime}}</span>
              </div>
              <div>
                <span class="span1">停车计时：</span>
                <span>{{detailData.useDate}}</span>
              </div>
            </div>
            <div class="baseInfoContentItem specialItem" v-if="!isPark">
              <div class="specialOne" style="width: 30%;">
                <span class="span1">待停用车位：</span>
                <span>{{detailData.parkingNum-detailData.warehouNum}}</span>
              </div>
              <div style="width: 30%;">
                <span class="span1">已停用车位：</span>
                <span>{{detailData.warehouNum}}</span>
              </div>
              <div>
                <span class="span1">异常停用车位：</span>
                <span>{{detailData.abnormalNum}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="operation">
          <div class="operationTitle">
            <div class="line"/>
            <span>操作信息</span>
          </div>
          <div class="operationTable">
            <el-table :data="operationData" border style="width: 100%">
              <el-table-column label="序号" align="center" width="30px">
                <div slot-scope="scope">{{scope.$index+1}}</div>
              </el-table-column>
              <el-table-column prop="operateTime" label="批次号" align="center"/>
              <el-table-column prop="operateTime" label="底盘号" align="center"/>
              <el-table-column prop="operateType" label="入库时间" align="center"/>
              <el-table-column prop="account" label="出库时间" align="center"/>
              <el-table-column prop="remark" label="停车时间" align="center"/>
            </el-table>
            <div class="paginationContainer">
              <span>共{{total}}条</span>
              <el-pagination
                background
                :page-sizes="[5, 10]"
                layout="sizes,prev, pager, next,jumper"
                :total="total"
                @size-change="contractSizeChange"
                @current-change="contractCurrentChange"
                @prev-click="contractCurrentChange"
                @next-click="contractCurrentChange"
              />
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="提示" :visible.sync="stateDialogVisible" width='350px' center>
      <div style="padding:20px;">
        <p style="color: rgb(136, 136, 136);margin-bottom: 10px;">当前车位已停放车辆，请选择车辆新停车位！</p>
        <div style="display: flex;align-items:center;margin-bottom: 10px;">
          <span style="font-weight: 700;color: #606266;"><span style="color:red;">*</span>选择楼层：</span>
          <el-select v-model="floor" filterable size="mini" style="width:150px" placeholder="请选择楼层">
            <el-option v-for="item in floorOption" :key="item.label" :label="item.label" :value="item.value"/>
          </el-select>
        </div>
        <div style="display: flex;align-items:center;margin-bottom: 10px;">
          <span style="font-weight: 700;color: #606266;margin-left: 15px;"><span style="color:red;">*</span>车位号：</span>
          <el-select v-model="park" filterable size="mini" style="width:150px" placeholder="请选择车位号">
            <el-option v-for="item in parkOption" :key="item.label" :label="item.label" :value="item.value"/>
          </el-select>
        </div>
        <div style="display: flex;align-items:center;justify-content: flex-end">
          <el-button class="searchBtn" size="mini" @click="stateClick">确认</el-button>
          <el-button class="resetBtn" size="mini" @click="stateDialogVisible=false">取消</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="提示" :visible.sync="errorDialogVisible" width='350px' center>
      <div style="padding:20px;">
        <div style="display: flex;align-items:center;margin-bottom: 10px;">
          <span style="font-weight: 700;color: #606266;"><span style="color:red;">*</span>异常车位数量：</span>
          <el-input v-model="errorNum" size="mini" placeholder="请输入异常车位数量" style="width:150px;"/>
        </div>
        <div style="display: flex;align-items:center;justify-content: flex-end">
          <el-button class="searchBtn" size="mini" @click="errorClick">确认</el-button>
          <el-button class="resetBtn" size="mini" @click="errorDialogVisible=false">取消</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {removeSpace} from "@/config/mUtils";
import divBorder from "@/components/divBorder";
import {
  getLocationInfo,
  locationDetail,
} from "@/service/basicfile"

export default {
  components: {
    divBorder,
  },

  data() {
    return {
      warehouseIpt:'',
      floorIpt:'',
      chassisIpt:'',
      timeIpt:'',
      dialogTitle:'',
      dialogVisible:false,
      addLoad:false,
      stateOption2:[
        {value:'',label:'全部',},
        {value:1,label:'停车中',},
        {value:0,label:'空闲中',},
        {value:2,label:'维修中',},
      ],
      floorOption:[
        {value:'-1',label:'-1',},
        {value:'-2',label:'-2',},
        {value:'-3',label:'-3',},
      ],
      parkOption:[
        {value:'100001',label:'100001',},
        {value:'100002',label:'100002',},
        {value:'100003',label:'100003',},
      ],
      warehouseOption:[
        {value:'仓库1',label:'仓库1',},
        {value:'仓库2',label:'仓库2',},
        {value:'仓库3',label:'仓库3',},
      ],
      isShow:false,
      isPark:false,
      companyData:{
        warehouse:'',
        floor:'',
        parking:'',
      },
      rules:{
        warehouse:[
          { required: true, message: '请选择仓库', trigger: 'change' },
        ],
        floor:[
          { required: true, message: '请选择楼层', trigger: 'change' },
        ],
        parking:[
          { required: true, message: '请输入车位号', trigger: 'blur' },
        ],
        state:[
          { required: true, message: '请选择状态', trigger: 'change' },
        ],
        name:[
          { required: true, message: '请输入车道名称', trigger: 'blur' },
        ],
        num:[
          { required: true, message: '请输入车道最多可停车数量', trigger: 'blur' },
        ],
      },
      floorArr:[],
      stateOption:[
        {value:'启用中',label:'启用中',},
        {value:'空闲中',label:'空闲中',},
        {value:'维修中',label:'维修中',},
      ],
      detailData:{state:'停车中',warehouse:'仓库1',car:'C区',floor:'-1',parking:'A01200',park:'渝A00000',time:'2021-9-26 20:43',timeout:'1天5时0分',num1:10,num2:10,num3:0},
      detailDialogVisible:false,
      operationData:[
        {operateTime:'DPH202154451',operateType:'2021-8-31 15:49:58',account:'2021-8-31 15:49:58',remark:'1天12时9分'},
        {operateTime:'DPH202154451',operateType:'2021-8-31 15:49:58',account:'--',remark:'0天1时21分'},
        {operateTime:'DPH202154451',operateType:'2021-8-31 15:49:58',account:'2021-8-31 15:49:58',remark:'1天12时9分'},
      ],
      page:1,
      size:5,
      total:0,
      errorDialogVisible:false,
      errorNum:'',
      stateDialogVisible:false,
      floor:'',
      park:'',
    };
  },
  computed:{
    divStyle() {
      return (val) => {
        switch (val) {
          case 1:
            return 'border-color:#66A6FF;'
          case 2:
            return 'border-color:#FBC967;'
          case 3:
            return 'border-color:#FC9F89;'
        }
      }
    },
    geyState() {
      return (state) => {
        switch (state) {
          case 0:
            return '空闲中'
          case 2:
            return '使用中'
          case 3:
            return '维修中'
        }
      }
    }
  },
  mounted() {
    this.$message({
      type: 'info',
      message: `需要先填写仓库名称！`,
      duration:5000,
      showClose:true,
    });
  },
  methods: {
    async _getLocationInfo(){
      const obj = {
        torehouseId:'7f9821d1588b4d3b9858901278d57a2d',
        // torehouseId:this.warehouseIpt,
        floorName:this.floorIpt,
        numberPlates :this.chassisIpt,
        status :this.timeIpt,
      };
      const res = await getLocationInfo(obj);
      if(res.status !== 0) return this.$message.error(res.message);
      this.isShow=true;
      this.isPark=res.data.locationType===2;
      this.floorArr=res.data.dataMap;
    },
    contractSizeChange(sizes){
      this.size=sizes;
    },
    contractCurrentChange(page){
      this.page=page;
    },
    searchBtn(){
      this.page = 1;
      this.warehouseIpt.trim();
      if(!this.warehouseIpt) return this.$message.warning('请输入仓库名称！');
      this._getLocationInfo();
    },
    resetBtn(){
      this.warehouseIpt='';
      this.floorIpt='';
      this.timeIpt='';
      this.chassisIpt='';
    },
    addBtn(){
      this.dialogTitle='添加车位';
      this.dialogVisible=true;
      this.companyData={
        warehouse:'',
        floor:'',
        parking:'',
      };
    },
    addBtn2(){
      this.dialogTitle='添加车道';
      this.dialogVisible=true;
      this.companyData={
        warehouse:'',
        floor:'',
        name:'',
        num:'',
      };
    },
    async change(id) {
      this.dialogTitle = this.isPark ? '修改车位' : '修改车道';
      this.dialogVisible = true;
      this.companyData = this.isPark ? {
        warehouse: '仓库1',
        floor: '-1',
        parking: '212121',
      } : {
        warehouse: '仓库1',
        floor: '-1',
        name: 'xxx车道',
        num: '10',
      };
    },
    changeState(state){
      if(state !== '启用中') {
        return this.$confirm('确定当前车位故障了吗？故障后将无法停放车辆！', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
        }).catch(() => {});
      }
      this.stateDialogVisible=true;
      this.floor='';
      this.park='';
    },
    stateClick(){
      if(!this.floor) return this.$message.warning('请选择楼层！');
      if(!this.park) return this.$message.warning('请选择车位号！');
      this.stateDialogVisible=false;
    },
    changeError(){
      this.errorDialogVisible=true;
      this.errorNum='';
    },
    errorClick(){
      if(!this.errorNum) return this.$message.warning('请输入异常车位数量！');
      if(Number(this.errorNum)>10) return this.$message.warning('最多可输入10！');
      this.errorDialogVisible=true;
    },
    deleteBtn(){
      this.$confirm('确定要删除当前车位吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
      }).catch(() => {});
    },
    async detail(id){
      const res = await locationDetail(id);
      if(res.status !== 0) return this.$message.error(res.message);
      this.operationData=res.data.operateRecordList;
      this.detailData=res.data;
      this.detailDialogVisible=true;
    },
    addClick(){
      this.companyData=removeSpace(this.companyData);
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.addLoad = true;
          this.addLoad = false;
          this.dialogVisible=false;
        } else return false;
      });
    },
    dialogClose(){
      this.dialogVisible=false;
      this.companyData={
        warehouse:'',
        floor:'',
        parking:'',
      };
      this.$refs.ruleForm.resetFields();
    },
  },
};
</script>


<style lang="scss">
.el-popover.contentPopover{
  padding:0;
}
</style>
<style lang="scss" scoped>
.mainContainer {
  width: 100%;
  padding: 20px 15px 0 25px;
  background-color: #fff;
  .line {
    width: 12px;
    height: 32px;
    background-color: rgba(51, 84, 131, 100);
    margin-right: 10px;
  }
  .line + span {
    font-size: 16px;
    color: rgba(51, 84, 131, 100);
    font-weight: 600;
  }
  .nav {
    width: 100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    &Container {
      width: 200px;
      display: flex;
      align-items: center;
      margin-right: 5px;
      margin-bottom: 5px;
      p {
        font-size: 14px;
        color: rgba(16, 16, 16, 100);
      }
    }
    &Btn {
      display: flex;
      align-items: center;
      margin-bottom: 5px;
    }
    ::v-deep {
      label.el-form-item__label {
        font-weight: 500;
        color: #101010;
      }
    }
  }
  .content{
    width:100%;
    display: flex;
    flex-direction: column;
    margin-top: 20px;
    &Item{
      width: 100%;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      &Title{
        font-weight: 700;
        font-size: 18px;
        color: rgb(16, 16, 16);
      }
      &Content{
        display: flex;
        align-items: center;
        justify-content: space-between;
        .btnContainer{
          display: flex;
          flex-direction: column;
        }
        &Item{
          width: 190px;
          height:160px;
          border:1px solid;
          margin-right: 20px;
          margin-bottom:20px;
          padding:0 5px;
          p{
            font-size: 12px;
            color: rgb(16, 16, 16);
          }
          &1{
            width:100%;
            height:100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            p:first-child{
              margin: 20px 0;
              font-weight: 700;
              font-size: 14px;
              color:#F9A606;
            }
            p:nth-child(2){
              font-weight: 700;
              font-size: 14px;
              text-align: left;
              width: 100%;
              margin-bottom: 10px;
            }
            p:nth-child(3){
              text-align: left;
              width: 100%;
              margin-bottom: 10px;
            }
            p:nth-child(4){
              width: 100%;
              margin-bottom: 5px;
            }
          }
          &2{
            width:100%;
            height:100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-around;
            p:first-child{
              margin:50px 0 30px 0;
              font-weight: 700;
              font-size: 16px;
              color: rgb(16, 16, 16);
            }
            p:nth-child(2){
              color: rgb(249, 166, 6);
              font-weight: 700;
              font-size: 18px;
              margin-bottom: 5px;
            }
          }
        }
      }
    }
  }
  .detail{
    width: 100%;
    padding: 10px 0 20px 20px;
    max-height:80vh;
    overflow: auto;
    .baseInfo{
      display: flex;
      flex-direction: column;
      &Title{
        display:flex;
        align-items:flex-end;
        p{
          font-weight: 700;
          font-size: 14px;
          color: rgba(51, 136, 255, 1);
          margin-left: 10px;
        }
      }
      &Content{
        display:flex;
        flex-direction: column;
        justify-content: space-between;
        padding:20px 23px 0 23px;
        &Item{
          margin-bottom: 20px;
          .span1{
            font-weight: 700;
          }
          span{
            font-size: 14px;
          }
          .specialOne{
            width:50%;
          }
        }
        .specialItem{
          display:flex;
          align-items:center;
        }
      }
    }
    .operation{
      display: flex;
      flex-direction: column;
      ::v-deep{
        .el-table td, .el-table th{
          padding:0;
        }
        .cell{
          font-size: 10px;
          padding:0;
        }
      }
      &Title{
        display:flex;
        align-items:flex-end;
        p{
          font-weight: 700;
          font-size: 14px;
          color: rgba(51, 136, 255, 1);
          margin-left: 10px;
        }
      }
      &Table{
        width:100%;
        margin-top: 10px;
        padding: 0 20px;
        .paginationContainer{
          //margin-right: auto;
          display: flex;
          align-items: center;
          margin: 20px 0;
          span{
            font-size: 13px;
          }
        }
        .operationIndex{
          display:flex;
          align-items: center;
          justify-content:space-around;
          span{
            color: rgba(58, 98, 215, 1);
            text-decoration: underline;
            font-size: 14px;
            &:hover{
              cursor: pointer;
            }
          }
        }
      }
    }
  }
  .company{
    width:100%;
    padding: 20px 10px;
    ::v-deep{
      .el-form-item{
        margin-bottom:15px;
      }
      .el-form-item__label{
        font-weight: 700;
      }
      .el-form-item__label{
        padding:0;
      }
      .el-form-item__content{
        position: relative;
      }
    }
    .btnContainer{
      width:100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 20px;
      button{
        margin: 0 15px;
      }
    }
  }
}
::v-deep{
  .el-dialog__header {
    padding: 9px 20px 9px;
    background: #335483;
  }
  .el-dialog__title {
    line-height: 24px;
    font-size: 14px;
    color: #FFFFFF;
  }
  .el-dialog__headerbtn{
    top:9px;
  }
  .el-dialog__headerbtn .el-dialog__close {
    color: #fff;
    font-size: 25px;
  }
  .el-dialog__body {
    padding: 0;
  }
  .el-table th>.cell{
    font-weight: 700!important;
  }
}
</style>
